const ENV = {
    firebase: {
        apiKey: 'AIzaSyDlifvDfA5vvblTswPeSyprmN1lMjsjez4',
        authDomain: 'bonelldoriga-81418.firebaseapp.com',
        databaseURL: 'https://bonelldoriga-81418.firebaseio.com',
        projectId: 'bonelldoriga-81418',
        storageBucket: 'bonelldoriga-81418.appspot.com',
        messagingSenderId: '450792076555',
        appId: '1:450792076555:web:38d31d03267ba541'
    }
}

export default ENV
global.ENV = ENV


// WEBPACK FOOTER //
// ./settings.js